import ActiveOptionViewState from '../../store/schema/ActiveOptionViewState';
import TimeZoneViewState from '../../store/schema/TimeZoneViewState';
import updateTimeZoneViewState from '../../actions/timeZone/updateTimezoneViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

// We are not using a mutatorAction since it does not log any datapoint - https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki?pagePath=%2FClient%2FArchitecture%2FAnalytics&wikiVersion=GBwikiMaster

const updateTimeZoneViewStateMutator = mutator(
    updateTimeZoneViewState,
    (actionMessage: { changes: TimeZoneViewState }) => {
        const { changes } = actionMessage;
        if (changes && !!Object.keys(changes).length) {
            // it should also have keys present so that this mutator is not used for clearing the state
            const store = getOptionsStore();
            if (store && store.activeViewState) {
                const viewState: TimeZoneViewState = store.activeViewState as TimeZoneViewState;
                store.activeViewState = {
                    ...viewState,
                    ...changes,
                } as ActiveOptionViewState;
            }
        }
    }
);

// exported only for testing purposes
export default updateTimeZoneViewStateMutator;
